/**
 * Helpers for MUI v6 TextField `slotProps` (Sonar S1874 — replaces InputProps/inputProps/InputLabelProps).
 */

/** Shallow-merge TextField slotProps objects (input, htmlInput, inputLabel, select, …). */
export function mergeTextFieldSlotProps(base = {}, patch = {}) {
  const merged = { ...base };
  for (const key of Object.keys(patch)) {
    const prev = merged[key];
    const next = patch[key];
    if (
      prev &&
      next &&
      typeof prev === "object" &&
      typeof next === "object" &&
      !Array.isArray(prev) &&
      !Array.isArray(next)
    ) {
      merged[key] = { ...prev, ...next };
    } else {
      merged[key] = next;
    }
  }
  return merged;
}

/** Strip legacy TextField slot keys from Autocomplete `params` before spread. */
export function omitLegacyTextFieldParams(params) {
  const {
    InputProps,
    inputProps,
    InputLabelProps,
    SelectProps,
    ...rest
  } = params;
  return {
    rest,
    legacy: {
      input: InputProps,
      htmlInput: inputProps,
      inputLabel: InputLabelProps,
      select: SelectProps,
    },
  };
}

/**
 * Build slotProps for Autocomplete renderInput TextField from MUI params + optional patch.
 */
export function autocompleteTextFieldSlotProps(params, slotPatch = {}) {
  const { legacy } = omitLegacyTextFieldParams(params);
  const base = {};
  if (legacy.input) base.input = legacy.input;
  if (legacy.htmlInput) base.htmlInput = legacy.htmlInput;
  if (legacy.inputLabel) base.inputLabel = legacy.inputLabel;
  if (legacy.select) base.select = legacy.select;
  if (params.slotProps) Object.assign(base, params.slotProps);
  return mergeTextFieldSlotProps(base, slotPatch);
}
